package link.erpango.quip.domain.entities

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DDeviceRegisterRequest(
    @SerialName("token") val token: String,
    @SerialName("platform") val platform: String,
    @SerialName("device_id") val deviceId: String? = null
)
